module.exports = __webpack_public_path__ + "static/media/linkSlidingInstallGuide.4acb3711.png";